var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadcrumb),function(item){return _c('el-breadcrumb-item',{key:item.name},[_vm._v(_vm._s(item.meta.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }